import { useCallback, useState } from "react";
export const stringifyOptions = (options) => Object.keys(options).reduce((acc, key) => {
    if (key === "days") {
        return acc;
    }
    if (options[key] === false) {
        return acc;
    }
    if (options[key] === true) {
        return `${acc}; ${key}`;
    }
    return `${acc}; ${key}=${options[key]}`;
}, "");
export const setCookie = (name, value, options = {}) => {
    const hostname = window.location.hostname;
    const optionsWithDefaults = {
        days: 365,
        path: "/",
        domain: hostname.includes("localhost")
            ? ""
            : hostname.split(".").slice(1).join("."),
        ...options,
    };
    const expires = new Date(Date.now() + optionsWithDefaults.days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}${stringifyOptions(optionsWithDefaults)}`;
};
export const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (const kv of cookies) {
        const [k, v] = kv.split("=");
        if (k === name) {
            return decodeURIComponent(v ?? "");
        }
    }
};
export const useCookie = (codec, key, baseOptions = {}) => {
    const [item, setItem] = useState(() => {
        const cookie = getCookie(key) ?? "";
        return codec.decode(cookie);
    });
    const updateItem = useCallback((value, options) => {
        setItem(value);
        setCookie(key, codec.encode(value), { ...baseOptions, ...options });
    }, [codec, key, baseOptions]);
    return [item, updateItem];
};
//# sourceMappingURL=useCookie.js.map